var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customerLogo"},[_c('a',{attrs:{"href":_vm.imgdata.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.imgdata.logo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }